/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Purchase } from './Purchase';
import {
    PurchaseFromJSON,
    PurchaseFromJSONTyped,
    PurchaseToJSON,
} from './Purchase';
import type { RecipientsInfo } from './RecipientsInfo';
import {
    RecipientsInfoFromJSON,
    RecipientsInfoFromJSONTyped,
    RecipientsInfoToJSON,
} from './RecipientsInfo';
import type { TermsConditions } from './TermsConditions';
import {
    TermsConditionsFromJSON,
    TermsConditionsFromJSONTyped,
    TermsConditionsToJSON,
} from './TermsConditions';

/**
 * 
 * @export
 * @interface CustomerStatus
 */
export interface CustomerStatus {
    /**
     * 
     * @type {TermsConditions}
     * @memberof CustomerStatus
     */
    latestTermsConditions?: TermsConditions;
    /**
     * 
     * @type {Array<Purchase>}
     * @memberof CustomerStatus
     */
    purchases?: Array<Purchase>;
    /**
     * 
     * @type {RecipientsInfo}
     * @memberof CustomerStatus
     */
    recipients?: RecipientsInfo;
}

/**
 * Check if a given object implements the CustomerStatus interface.
 */
export function instanceOfCustomerStatus(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CustomerStatusFromJSON(json: any): CustomerStatus {
    return CustomerStatusFromJSONTyped(json, false);
}

export function CustomerStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestTermsConditions': !exists(json, 'latestTermsConditions') ? undefined : TermsConditionsFromJSON(json['latestTermsConditions']),
        'purchases': !exists(json, 'purchases') ? undefined : ((json['purchases'] as Array<any>).map(PurchaseFromJSON)),
        'recipients': !exists(json, 'recipients') ? undefined : RecipientsInfoFromJSON(json['recipients']),
    };
}

export function CustomerStatusToJSON(value?: CustomerStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latestTermsConditions': TermsConditionsToJSON(value.latestTermsConditions),
        'purchases': value.purchases === undefined ? undefined : ((value.purchases as Array<any>).map(PurchaseToJSON)),
        'recipients': RecipientsInfoToJSON(value.recipients),
    };
}

